var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H10V12H22V10Z",
    fill: "#0000C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H22V16H10V14Z",
    fill: "#0000C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H10V20H22V18Z",
    fill: "#0000C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5858 27.4142L22 26.8284L21.4142 27.4142C20.6332 28.1953 19.3668 28.1953 18.5858 27.4142L18 26.8284L17.4142 27.4142C16.6332 28.1953 15.3668 28.1953 14.5858 27.4142L14 26.8284L13.4142 27.4142C12.6332 28.1953 11.3668 28.1953 10.5858 27.4142L10 26.8284L9.41421 27.4142C8.84222 27.9862 7.98198 28.1573 7.23463 27.8478C6.48728 27.5382 6 26.8089 6 26V6C6 4.89543 6.89543 4 8 4H24C25.1046 4 26 4.89543 26 6V26C26 26.8089 25.5127 27.5382 24.7654 27.8478C24.018 28.1573 23.1578 27.9862 22.5858 27.4142ZM12 26L10 24L8 26V6H24V26L22 24L20 26L18 24L16 26L14 24L12 26Z",
    fill: "#0000C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.795a771d945e15ce0750106d561b3ae7.svg";
export { ForwardRef as ReactComponent };